var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "next-save__buttons" },
    [
      _vm.displayedNextButton
        ? _c(
            "mds-button",
            {
              attrs: {
                "icon-right": "angle-right",
                variation: "secondary",
                id: "check-missing-fields",
                disabled: _vm.disabledNextButton,
              },
              on: {
                click: function ($event) {
                  return _vm.$emit("next-step", _vm.activeStep)
                },
              },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.translate("scheduler.modal.next.button")) +
                  "\n  "
              ),
            ]
          )
        : _c(
            "div",
            { staticClass: "scheduler-modal__save-buttons" },
            [
              _c(
                "mds-button",
                {
                  attrs: { variation: "primary", disabled: _vm.disableButtons },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("save", false)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.translate(_vm.saveOrEditLabel)) +
                      "\n    "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("mds-button", {
                attrs: {
                  variation: "primary",
                  icon: "caret-down",
                  id: "triger-save-button",
                  disabled: _vm.disableButtons,
                },
                on: {
                  click: function ($event) {
                    _vm.toggle = !_vm.toggle
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "mds-popover",
                {
                  staticClass: "scheduler-modal__popover",
                  attrs: {
                    "triggered-by": "triger-save-button",
                    position: ["top-left"],
                  },
                  model: {
                    value: _vm.toggle,
                    callback: function ($$v) {
                      _vm.toggle = $$v
                    },
                    expression: "toggle",
                  },
                },
                [
                  _c(
                    "mds-list-group",
                    {
                      staticClass: "scheduler-modal__popover-options",
                      attrs: { size: "small" },
                    },
                    [
                      _c("mds-list-group-item", {
                        attrs: {
                          text: _vm.translate(_vm.saveAndScheduleLabel),
                        },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.onSaveClick.apply(null, arguments)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }